const EXPERIENCE_TYPE = {
    CURRENT: 'current',
    NEW: 'new'
};

const COLOR_SWATCH_DISPLAY = {
    CURRENT: 'current',
    SHOW_HYBRID: 'showHybrid'
};

const NEXT_DAY_DELIVERY_MESSAGE = {
    ORDER_NOW: 'Order now, get it tomorrow',
    ORDER_TODAY: 'Order today'
};

const ORDER_TYPE = {
    STANDARD: 'standard',
    BOPIS: 'bopis',
    SDD: 'sdd'
};

const SHOW_ML_DRIVEN_PROMOS = {
    CURRENT: 'hidePromos',
    NEW: 'showPromos'
};

const ML_VS_CONSTRUCTOR = {
    ML: 'ml',
    CONSTRUCTOR: 'constructor'
};

const SHOW_BASKET_CC_BANNER_8_PERCENT_BACK = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const SHOW_PRODUCT_THUMBNAILS_CHECKOUT = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const PURCHASED_FLAG_ON_GRID_PAGES_EXPERIENCE = {
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const TRENDING_CONTENT = {
    CHALLENGER_ONE: 'challengerOne'
};

const STAR_RATING_ON_CATALOG_EXPERIENCE = {
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo',
    CHALLENGER_THREE: 'challengerThree',
    CHALLENGER_FOUR: 'challengerFour'
};

const REORDER_FULFILLMENT_OPTIONS_EXPERIENCE = {
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const REORDER_SECTION_PAGE_PDP_EXPERIENCE = {
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo',
    CHALLENGER_THREE: 'challengerThree'
};

const SHOW_HIGHLIGHT_LAYER_WITH_PDP = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne'
};

const SHOW_REORDER_CAROUSEL_HPSO = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo',
    CHALLENGER_THREE: 'challengerThree',
    CHALLENGER_FOUR: 'challengerFour',
    CHALLENGER_FIVE: 'challengerFive'
};

const SHOW_REORDER_CAROUSEL_HPSI = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo',
    CHALLENGER_THREE: 'challengerThree',
    CHALLENGER_FOUR: 'challengerFour',
    CHALLENGER_FIVE: 'challengerFive'
};

const SHOW_PRICE_INFO_ATB = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo',
    CHALLENGER_THREE: 'challengerThree'
};

export {
    REORDER_FULFILLMENT_OPTIONS_EXPERIENCE,
    EXPERIENCE_TYPE,
    COLOR_SWATCH_DISPLAY,
    NEXT_DAY_DELIVERY_MESSAGE,
    ORDER_TYPE,
    SHOW_ML_DRIVEN_PROMOS,
    ML_VS_CONSTRUCTOR,
    SHOW_BASKET_CC_BANNER_8_PERCENT_BACK,
    SHOW_PRODUCT_THUMBNAILS_CHECKOUT,
    PURCHASED_FLAG_ON_GRID_PAGES_EXPERIENCE,
    TRENDING_CONTENT,
    STAR_RATING_ON_CATALOG_EXPERIENCE,
    SHOW_HIGHLIGHT_LAYER_WITH_PDP,
    SHOW_REORDER_CAROUSEL_HPSO,
    SHOW_REORDER_CAROUSEL_HPSI,
    SHOW_PRICE_INFO_ATB,
    REORDER_SECTION_PAGE_PDP_EXPERIENCE
};
